module.exports = __webpack_public_path__ + "static/IBMPlexSans-Bold-e61f023df49811493563b2767a1e368f.woff2";